<template>
	<div class="workbook-page">
		<div :class="['ui', 'bottom', 'attached', numbers[worksheets.length], 'item', 'menu']">
			<router-link
				v-for="ws in worksheets"
				:key="ws.id"
				:to="{
        name: 'workbook-page',
        params: { workbook: workbook, worksheet: ws.id }
      }"
				:class="[{active: worksheet === ws.id}, 'item', 'menu--item']"
				:style="{ 'background-color': worksheet === ws.id ? 'rgb(126, 147, 169)' : '', 'color': worksheet === ws.id ? 'white' : ''}"
				:data-id="ws.id"
			>{{ ws.title }}
			</router-link>
		</div>

		<div class="dash-sidebar">
			<filter-control ref="sidebarFilters" :name="name" @submit="requestData"/>
		</div>

		<div class="dash-container">
			<div :class="['ui', 'inverted', { active: loading }, 'dimmer']">
				<div class="ui text loader"></div>
			</div>

			<template v-if="(Object.keys(chart).length || Object.keys(grid).length) || url">
				<div class="ui grid">
					<div class="one wide column">
						<div class="ui form">
							<div class="inline fields">
								<div class="field">
									<button
										class="ui button basic icon small"
										:data-tooltip="i18n('Action.goBackhome')"
										data-position="right center"
										@click="goBack()"
									>
										<i class="home icon"></i>
									</button>
								</div>
							</div>
						</div>
					</div>
					<div class="seven wide column">
						<div class="ui header grey">
							{{ title }}
							<div class="sub header">{{ filtersSummary }}</div>
						</div>
					</div>
					<div class="right aligned eight wide column">
						<notifications-button/>
						<div class="ui icon basic buttons" style="margin-right: 1rem">
							<button
								v-if="Object.keys(grid).length"
								class="ui button"
								:data-tooltip="i18n('Action.ExportToExcel')"
								data-position="bottom center"
								@click="exportGrid"
							>
								<i class="file excel outline icon"></i>
							</button>
							<button
								v-if="Object.keys(chart).length"
								class="ui button"
								:title="i18n('Action.SaveAsImage')"
								@click="exportChart"
							>
								<i class="file image outline icon"></i>
							</button>
						</div>
						<a
							href="mailto:suportegig@neocom.info"
							class="ui icon basic button"
							data-tooltip="suportegig@neocom.info"
							data-position="left center"
						>
							<i class="mail icon"></i>
						</a>
					</div>
				</div>
				<div class="ui segment">
					<kendo-treemap
						v-if="Object.keys(chart).length && chart.type === 'treemap'"
						ref="chartWidget"
						:height="getDocumentHeight(2.5)"
						:dataModel="chart.dataModel"
						:dataSource="chart.dataSource"
					/>

					<kendo-bubble
						v-else-if="Object.keys(chart).length && chart.type === 'bubble'"
						ref="chartWidget"
						:height="getDocumentHeight(2.5)"
						:type="chart.type"
						:axis="chart.axis"
						:category="chart.category"
						:format="chart.format"
						:series="chart.series"
						:dataSource="chart.dataSource"
					/>

					<kendo-chart
						v-else-if="Object.keys(chart).length"
						ref="chartWidget"
						:height="getDocumentHeight(2.5)"
						:type="chart.type"
						:series="chart.series"
						:category="chart.category"
						:format="chart.format"
						:dataSource="chart.dataSource"
					/>

					<kendo-grid
						v-if="Object.keys(grid).length && grid.type === 'grid'"
						ref="gridWidget"
						:columns="grid.columns"
						:height="Object.keys(chart).length ? getDocumentHeight(3) : getDocumentHeight(1.5)"
						:dataSource="grid.dataSource"
					/>

					<kendo-pivot
						v-else-if="Object.keys(grid).length && grid.type === 'pivot'"
						ref="gridWidget"
						:height="getDocumentHeightAbsolute(-220)"
						:dataSource="grid.dataSource"
					/>

					<div v-if="url" :style="{ height: getDocumentHeightAbsolute(-220) + 'px' }">
						<iframe frameborder="0" :src="url"></iframe>
					</div>
				</div>
			</template>

			<div v-if="(!Object.keys(chart).length && !Object.keys(grid).length) && !url" class="ui grid">
				<div class="row">
					<div class="eight wide column">
						<div class="ui form">
							<div class="inline fields">
								<div
									class="field"
									:data-tooltip="i18n('Action.goBackhome')"
									data-position="right center"
								>
									<button class="ui button basic icon small" @click="goBack()">
										<i class="home icon"></i>
									</button>
								</div>
							</div>
						</div>
					</div>
					<div class="right aligned eight wide column">
						<notifications-button/>
						<a
							href="mailto:suportegig@neocom.info"
							class="ui icon basic button"
							data-tooltip="suportegig@neocom.info"
							data-position="left center"
						>
							<i class="mail icon"></i>
						</a>
					</div>
				</div>
				<div class="row">
					<div class="sixteen wide column">
						<div class="ui basic padded segment">
							<div class="ui container">
								<div class="ui icon message">
									<i class="area chart icon"></i>
									<div class="content">
										<div class="header">Bem vindo ao dashboard!</div>
										<p>Selecione um filtro para começar…</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  import _ from 'lodash';
  import {mapActions, mapGetters} from 'vuex';

  import KendoBubble from '@/components/kendo-bubble/kendo-bubble';
  import KendoChart from '@/components/kendo-chart/kendo-chart';
  import KendoGrid from '@/components/kendo-grid/kendo-grid';
  import KendoPivot from '@/components/kendo-pivot/kendo-pivot';
  import KendoTreemap from '@/components/kendo-treemap/kendo-treemap';
  import NotificationsButton from '@/components/notifications-button/notifications-button';
  import FilterControl from '@/modules/neodash/components/filter-control/filter-control';

  import {httpMixin, i18nMixin} from '@/modules/neodash/mixins';

  import {CONFIG} from '@/config';
  import {
    DASHBOARD_DELETE_DATA,
    DASHBOARD_GET_CHART_DATA,
    DASHBOARD_GET_GRID_DATA,
    DASHBOARD_GET_IFRAME_URL,
    DASHBOARD_GET_WORKSHEETS,
    DASHBOARD_UPDATE_DATA,
    DASHBOARD_UPDATE_WORKSHEETS_DATA
  } from '@/modules/neodash/store/modules/dashboard/types';
  import {FILTERS_GET_ID, FILTERS_UPDATE_DATA} from '@/modules/neodash/store/modules/filters/types';
  import {AUTH_GET_TOKEN, AUTH_GET_USERNAME} from '@/store/modules/authentication/types';
  import {GET_LOADING} from '@/store/types';

  export default {
    props: {
      workbook: {
        type: String,
        required: true
      },
      worksheet: {
        type: String
      }
    },

    data() {
      return {
        numbers: ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten']
      };
    },

    mixins: [httpMixin, i18nMixin],

    computed: {
      ...mapGetters({
        worksheets: DASHBOARD_GET_WORKSHEETS,
        loading: GET_LOADING,
        grid: DASHBOARD_GET_GRID_DATA,
        chart: DASHBOARD_GET_CHART_DATA,
        url: DASHBOARD_GET_IFRAME_URL,
        currentFilterId: FILTERS_GET_ID,
        userName: AUTH_GET_USERNAME,
        userToken: AUTH_GET_TOKEN
      }),

      name() {
        return this.worksheet || this.workbook;
      },

      title() {
        return _.find(this.worksheets, ws => ws.id === this.worksheet).title;
      },

      filtersSummary() {
        return (this.$refs.sidebarFilters || {}).filtersSummary;
      },
    },

    methods: {
      ...mapActions({
        updateFiltersData: FILTERS_UPDATE_DATA,
        updateWorksheetData: DASHBOARD_UPDATE_WORKSHEETS_DATA,
        updateWorkbookData: DASHBOARD_UPDATE_DATA
      }),

      goBack() {
        this.$router.push({
          name: 'home'
        });
      },

      exportGrid() {
        if (this.$refs.gridWidget) {
          this.$refs.gridWidget.exportTable();
        }
      },

      exportChart() {
        if (this.$refs.chartWidget) {
          this.$refs.chartWidget.exportChart();
        }
      },

      requestData(data) {
        const req = {
          workbook: this.workbook,
          worksheet: this.worksheet,
          apikey: this.userToken,
          user: this.userName
        };

        _.forEach(data, (val, key) => {
          req[key] = _.isArray(val.value) ? _.join(val.value, ',') : val.value;
        });

        this.http
            .post(`${CONFIG.URL.NEODASH_API}/api/dashboard/workbook/${req.workbook}/${req.worksheet}`, req)
            .then(res => {
              const worksheet = _.find(this.worksheets, ws => ws.id === req.workbook);
              this.updateWorkbookData(Object.assign({}, worksheet, res.data));
            })
            .catch(err => err);
      },

      requestFilters() {
        this.$store.dispatch(DASHBOARD_DELETE_DATA);

        const req = {
          workbook: this.workbook,
          worksheet: this.worksheet
        };

        if (this.currentFilterId === this.workbook) {
          this.updateWorksheetData(this.worksheets);
          return;
        }

        this.http.get(`${CONFIG.URL.NEODASH_API}/api/dashboard/workbook/${req.workbook}/`, req).then(res => {
          this.updateFiltersData({...res.data, id: this.workbook});
          this.updateWorksheetData(res.data.worksheets);
        });
      },

      getDocumentHeight(val = 1) {
        return Math.round(
            Math.max(
                document.body.scrollHeight,
                document.body.offsetHeight,
                document.documentElement.clientHeight,
                document.documentElement.scrollHeight,
                document.documentElement.offsetHeight
            ) / val
        );
      },

      getDocumentHeightAbsolute(val = -100) {
        return Math.round(
            Math.max(
                document.body.scrollHeight,
                document.body.offsetHeight,
                document.documentElement.clientHeight,
                document.documentElement.scrollHeight,
                document.documentElement.offsetHeight
            ) + val
        );
      }
    },

    created() {
      // console.log('workbookPage -> created');
      this.requestFilters();
    },

    watch: {
      workbook() {
        this.requestFilters();
      },

      worksheet() {
        this.$refs.sidebarFilters.reload();
        this.updateWorkbookData({});
      }
    },

    components: {
      FilterControl,
      KendoBubble,
      KendoChart,
      KendoGrid,
      KendoPivot,
      KendoTreemap,
      NotificationsButton
    }
  };
</script>

<style lang="scss" scoped>
	@import "../../../../main";

	$heightMenu: 40px;
	$heightContainers: calc(100vh - #{$heightNavBar} - #{$heightMenu});

	$widthSideBar: 220px;

	.workbook-page {
		display: flex;
		flex-wrap: wrap;

		.menu {
			width: 100vw;
			height: $heightMenu;
		}

		.dash-sidebar {
			overflow-y: auto;
			width: $widthSideBar;
			height: $heightContainers;
			background-color: #f1f1f1;
			border-right: 1px solid #cccccc;
			box-shadow: 1px 0 0 #fff;
			z-index: 1;
			padding: 20px;

			.k-widget.k-tooltip {
				width: 93%;
			}
		}

		.dash-container {
			overflow-y: auto;
			padding: 20px;
			background-color: #f1f1f1;
			height: $heightContainers;
			width: calc(99vw - #{$widthSideBar});
		}
	}

	iframe {
		width: 100%;
		height: 100%;
	}

	.ui.basic.button,
	.ui.basic.buttons {
		background-color: #ffffff !important;
		box-shadow: inset 0 1px 0 hsla(0, 0%, 100%, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05) !important;
		border: 1px solid #ccc !important;
	}
</style>
